import { generateMongoObjectId } from '@/helpers/generateMongoObjectId'
import {
  addNewPrescription,
  deletePrescription,
  fetchSinglePrescription,
  prescriptionReport,
  putPrescription,
} from '@/services/prescriptions'
import {
  FETCH_PRESCRIPTIONS,
  PRESCRIPTION_CREATED,
  PRESCRIPTION_DELETE,
  PRESCRIPTION_SELECTED,
  PRESCRIPTION_UPDATED,
  RESET_PRESCRIPTION_SELECTED,
} from '@/store/prescriptions'
import { showToast } from '@/utils/toast'

const getAllPrescriptions = (fetchAllPrescriptions) => async (dispatch) => {
  dispatch(FETCH_PRESCRIPTIONS(fetchAllPrescriptions))
}

const postNewPrescriptions = (data) => async (dispatch) => {
  try {
    if (!data._id) {
      data._id = generateMongoObjectId()
    }
    let newPrescription = await addNewPrescription(data)
    newPrescription.patientCentre = data.patientCentre
    newPrescription.doctorCentre = data.doctorCentre

    dispatch(PRESCRIPTION_CREATED(newPrescription))
    if (updatePrescription) {
      showToast('Receta guardada correctamente', 'success')
    }
  } catch (data) {
    handlePrescriptionError(data)
  }
}

const deletePrescriptionAdded = (id) => async (dispatch) => {
  try {
    await deletePrescription(id)
    dispatch(PRESCRIPTION_DELETE(id))
    showToast('Receta eliminada correctamente', 'success')
  } catch (error) {
    const { message } = error
    console.log(message)
  }
}

const updatePrescription = (data, hideAlert) => async (dispatch) => {
  try {
    let prescriptionUpdated = await putPrescription(data)

    prescriptionUpdated.patientCentre = data.patientCentre
    prescriptionUpdated.doctorCentre = data.doctorCentre

    dispatch(PRESCRIPTION_UPDATED(prescriptionUpdated))

    if (prescriptionUpdated && !hideAlert) {
      showToast('Receta actualizada correctamente', 'success')
    }
  } catch (data) {
    handlePrescriptionError(data.error)
  }
}

const selectedPrescription = (id) => async (dispatch) => {
  try {
    const singlePrescription = await fetchSinglePrescription(id)
    dispatch(PRESCRIPTION_SELECTED(singlePrescription))
  } catch (error) {
    const { message } = error
    console.log(message)
  }
}

const resetSelectedPrescription = () => async (dispatch) => {
  try {
    dispatch(RESET_PRESCRIPTION_SELECTED())
  } catch (error) {
    const { message } = error
    console.log(message)
  }
}

const sendReportPrescriptionByEmail = (data) => async (dispatch) => {
  try {
    await prescriptionReport(data)
    showToast('La receta se ha enviado con éxito', 'success')
  } catch (error) {
    const { message } = error
    console.log(message)
    showToast('upps! Algo salió mal, intenta nuevamente', 'error')
  }
}

const handlePrescriptionError = (data) => {
  if (data.errData) {
    if (data.errData.error === 'QBI156') {
      return showToast('Debe ingresar un número de documento válido para el profesional', 'error')
    }
    if (data.errData.error === 'QBI168') {
      return showToast('Debe ingresar un número de documento válido para el paciente', 'error')
    }
    showToast('Debe ingresar número de afiliado', 'error')
  }
  showToast(data.error, 'error')
}

export {
  deletePrescriptionAdded,
  getAllPrescriptions,
  postNewPrescriptions,
  resetSelectedPrescription,
  selectedPrescription,
  sendReportPrescriptionByEmail,
  updatePrescription,
}
